import {
  faArrowsRotate,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FlexBox,
  JoonUIColor,
  QuestStatus,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useShallow } from "zustand/react/shallow"

import { useCatchUpStore } from "./useCatchUpStore"

const CatchUpCardStatusOverlay = ({
  questStatusProp,
}: {
  questStatusProp?: QuestStatus
}) => {
  const questStatus = useCatchUpStore(useShallow((state) => state.questStatus))
  const questStatusToUse = questStatusProp || questStatus
  const { t } = useTranslation()

  const overlayStyles = useMemo(() => {
    switch (questStatusToUse) {
      case QuestStatus.REJECTED:
        return {
          background: "rgba(255, 233, 233, 0.80)",
          primaryColor: JoonUIColor.semantic.alert,
          icon: (
            <FontAwesomeIcon
              icon={faThumbsDown}
              color={JoonUIColor.semantic.alert}
              fontSize="54px"
            />
          ),
          text: t("CATCHUP_REJECTED_EXCL"),
        }
      case QuestStatus.VERIFIED:
        return {
          background: "rgba(220, 252, 244, 0.80)",
          primaryColor: JoonUIColor.semantic.success,
          icon: (
            <FontAwesomeIcon
              icon={faThumbsUp}
              color={JoonUIColor.semantic.success}
              fontSize="54px"
            />
          ),
          text: t("CATCHUP_APPROVED_EXCL"),
        }
      case QuestStatus.RETRY:
        return {
          background: "rgba(233, 233, 255, 0.80)",
          primaryColor: JoonUIColor.semantic.primary,
          icon: (
            <FontAwesomeIcon
              icon={faArrowsRotate}
              color={JoonUIColor.semantic.primary}
              fontSize="54px"
            />
          ),
          text: t("CATCHUP_RETRY_REQUESTED"),
        }
      default:
        return {}
    }
  }, [questStatusToUse, t])

  if (!questStatusToUse) return <></>

  return (
    <FlexBox
      direction="row"
      align="center"
      justify="center"
      wrap={false}
      gap={SPACING.space3}
      style={{
        height: "100%",
        width: "100%",
        border: `3px solid ${overlayStyles.primaryColor}`,
        background: overlayStyles.background,
        position: "absolute",
        top: 0,
        borderRadius: SPACING.space4,
        zIndex: 4000,
      }}
    >
      {overlayStyles.icon}
      <Typography variant="h2" color={overlayStyles.primaryColor}>
        {overlayStyles.text}
      </Typography>
    </FlexBox>
  )
}
export default CatchUpCardStatusOverlay
